import { useAxios } from "./api";

const basePath = "/api/v1/machines";
const endpoint = {
  getMachineById: { path: (id) => `${basePath}/${id}`, method: "GET" },
};

export const useGetMachineById = () => {
  return [
    useAxios(
      {
        method: endpoint.getMachineById.method,
      },
      { manual: true }
    ),
    (id) => endpoint.getMachineById.path(id),
  ];
};
